// Turns a rejected API call into a message the user can read.
// The backend reports errors as {"error": text}, {"detail": text} or DRF field errors
// ({field: [text]}), depending on the view.

export const NETWORK_ERROR_MESSAGE = 'A network error occurred. Please check your connection and try again.';

const DEFAULT_FALLBACK = 'Something went wrong. Please try again.';

const isPlainObject = (value) => Object.prototype.toString.call(value) === '[object Object]';

const isNonEmptyString = (value) => typeof value === 'string' && value.trim() !== '';

// The first non-empty string in a nested JSON value, depth first.
const findFirstString = (value) => {
    if (isNonEmptyString(value)) return value;
    if (Array.isArray(value) || isPlainObject(value)) {
        for (const item of Object.values(value)) {
            const found = findFirstString(item);
            if (found) return found;
        }
    }
    return null;
};

export const getApiErrorMessage = (err, fallback = DEFAULT_FALLBACK) => {
    const fallbackText = isNonEmptyString(fallback) ? fallback : DEFAULT_FALLBACK;

    if (!err || !err.response) {
        return err && err.isAxiosError ? NETWORK_ERROR_MESSAGE : fallbackText;
    }

    const { data } = err.response;
    if (!isPlainObject(data)) return fallbackText;

    if (isNonEmptyString(data.error)) return data.error;
    if (isNonEmptyString(data.detail)) return data.detail;

    return findFirstString(data) || fallbackText;
};

export const isInsufficientTokensError = (err) => {
    const response = err && err.response;
    return Boolean(
        response &&
        response.status === 400 &&
        isPlainObject(response.data) &&
        response.data.detail === 'Insufficient tokens'
    );
};
